export default "__VITE_ASSET__caf5ed65__"